var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",attrs:{"id":"app"}},[_c('pev2',{attrs:{"plan-source":_vm.plan,"plan-query":_vm.query}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }